import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			dependent_visible: "q_armed_forces_status",
			dependent_visible_values: ["C", "P"],
			options: [
				{
					value: "A",
					text: "On active duty U.S. military"
				},
				{
					value: "V",
					text: "Veteran of U.S. Armed Forces"
				},
				{
					value: "R",
					text: "U.S. Reserves of National Guard"
				}
			]
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
